import currencyFormatter from '../../../utils/currencyFormatter';

const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

const formatMoney = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return null;
  return currencyFormatter.format(number);
};

const pushLine = (lines, label, value) => {
  const text = value == null || value === '' ? '' : String(value).trim();
  if (!text) return;
  lines.push(`<strong>${escapeHtml(label)}:</strong> ${escapeHtml(text)}`);
};

/**
 * Monta HTML de contexto do pedido/cotação para e-mails automáticos.
 */
export const buildPedidoCompraEmailContextHtml = ({
  pedidoCompraData = {},
  compraCotacaoData = {},
  justificativa = '',
} = {}) => {
  const lines = [];

  const pedidoRef = pedidoCompraData.pedidoCompra_num
    || (Number(pedidoCompraData.pedidoCompra_id)
      ? `PC-${pedidoCompraData.pedidoCompra_id}`
      : '');
  pushLine(lines, 'Pedido de compra', pedidoRef);
  pushLine(lines, 'Descrição do pedido', pedidoCompraData.pedidoCompra_desc);

  pushLine(
    lines,
    'Fornecedor',
    compraCotacaoData.compraCotacao_nomeInteressado,
  );
  pushLine(
    lines,
    'Descrição da proposta',
    compraCotacaoData.compraCotacao_desc,
  );

  const valorProposta = formatMoney(compraCotacaoData.compraCotacao_vlr);
  if (valorProposta) pushLine(lines, 'Valor da proposta', valorProposta);

  const justificativaText = String(justificativa || '').trim();
  if (justificativaText) {
    pushLine(lines, 'Justificativa da revisão', justificativaText);
  }

  if (lines.length <= 0) return '';
  return lines.join('<br/>');
};

export const EMAIL_TEXT_CONVITE_PROPOSTA = {
  assunto: 'Convite para envio de proposta - Oikos',
  mensagemIntro: 'Você está sendo convidado(a) a enviar sua proposta para contribuir com nossos serviços. Utilize o link abaixo para acessar o formulário e registrar sua proposta:',
  formLinkLabel: 'Acesse o formulário para enviar sua proposta',
  corpoTitulo: 'Detalhes do pedido',
};

export const EMAIL_TEXT_ENVIAR_FORNECEDOR = {
  assunto: 'Solicitação de informações - Contratação Oikos',
  mensagemIntro: 'Sua proposta avançou no processo de contratação. Para darmos continuidade, solicitamos que preencha as informações necessárias no formulário abaixo:',
  formLinkLabel: 'Acesse o formulário e envie suas informações',
  corpoTitulo: 'Detalhes da cotação',
};

export const EMAIL_TEXT_REENVIAR_FORNECEDOR = {
  assunto: 'Revisão solicitada - Informações da contratação Oikos',
  mensagemIntro: 'Recebemos as informações enviadas, porém é necessário revisá-las e reenviá-las. Utilize o link abaixo para corrigir os dados e submeter novamente o formulário:',
  formLinkLabel: 'Acesse o formulário para corrigir e reenviar suas informações',
  corpoTitulo: 'Detalhes e justificativa',
};
